(() => {
  const root = document.querySelector('[data-dilba-request]');
  if (!root || root.dataset.requestReady === 'true') return;
  root.dataset.requestReady = 'true';

  const formSection = root.querySelector('#anfrageformular');
  const topicSelect = root.querySelector('#DilbaRequestTopic');
  const topicHelp = root.querySelector('[data-topic-help]');
  const subjectInput = root.querySelector('[data-request-subject]');
  const choices = Array.from(root.querySelectorAll('[data-request-topic]'));

  const topicCopy = {
    'Bauteilfertigung & 3D-Druck': 'Nennen Sie uns Einsatz, Stückzahl, Materialwunsch und Abmessungen. Für eine direkte Preisberechnung können Sie Ihre CAD-Datei auch im Online-Konfigurator hochladen.',
    'Metall-3D-Druck SLM / LPBF': 'Nennen Sie Werkstoff, Stückzahl, Abmessungen, Toleranzen und gewünschte Nachbearbeitung. Direkt kalkulierbare Metallteile können Sie auch im Online-Konfigurator bestellen.',
    'Laserauftragsschweißen & großformatiges Metall-AM': 'Beschreiben Sie Grundwerkstoff, Bauteilgröße, Reparatur- oder Beschichtungsbereich, Belastung und Prüfanforderungen. Auch großformatiger Metallaufbau per MELD/AFSD ist möglich.',
    'Formguss & Walzenguss': 'Nennen Sie Bauteil- oder Walzenart, Werkstoff, Abmessungen, Stückzahl, Einsatzbedingungen sowie Anforderungen an Wärmebehandlung, Prüfung und Bearbeitung.',
    'CNC & konventionelle Fertigung': 'Bitte ergänzen Sie Werkstoff, Stückzahl, Toleranzen, Oberfläche und vorhandene Zeichnungsdaten.',
    'CAD, 3D-Scan & Reverse Engineering': 'Sagen Sie uns, ob ein Musterteil, eine Zeichnung oder bereits digitale Daten vorhanden sind und welches Ergebnis Sie benötigen.',
    '3D-Drucker oder 3D-Scanner kaufen': 'Nennen Sie Einsatzgebiet, gewünschte Materialien, Bauraum und vorhandene Erfahrung. Wir beraten zu System, Zubehör, Inbetriebnahme und Schulung.',
    'Roboter & Automation kaufen': 'Beschreiben Sie Aufgabe, Einsatzort und gewünschte Funktionen. Wir beraten zu Service-, Transport- und Humanoidrobotik sowie zur Einführung im Betrieb.',
    'Lasercutter & weitere Technik': 'Nennen Sie Material, Bearbeitungsgröße und Anwendung. Wir berücksichtigen Maschine, Absaugung, Zubehör und Einweisung.',
    'Material, Ersatzteile & Zubehör': 'Bitte nennen Sie Gerät, Hersteller, Material oder Ersatzteil sowie die benötigte Menge.',
    'Schulung, Inbetriebnahme & Service': 'Teilen Sie uns System, Standort, Teilnehmerzahl und gewünschten Leistungsumfang mit.',
    'Allgemeine Beratung / Sonstiges': 'Beschreiben Sie kurz Ihr Vorhaben. Wir ordnen die Anfrage intern dem passenden Ansprechpartner zu.'
  };

  const queryMap = {
    fertigung: 'Bauteilfertigung & 3D-Druck',
    bauteil: 'Bauteilfertigung & 3D-Druck',
    metall: 'Metall-3D-Druck SLM / LPBF',
    slm: 'Metall-3D-Druck SLM / LPBF',
    lpbf: 'Metall-3D-Druck SLM / LPBF',
    laser: 'Laserauftragsschweißen & großformatiges Metall-AM',
    auftragsschweissen: 'Laserauftragsschweißen & großformatiges Metall-AM',
    lmd: 'Laserauftragsschweißen & großformatiges Metall-AM',
    guss: 'Formguss & Walzenguss',
    formguss: 'Formguss & Walzenguss',
    walzenguss: 'Formguss & Walzenguss',
    cnc: 'CNC & konventionelle Fertigung',
    scan: 'CAD, 3D-Scan & Reverse Engineering',
    drucker: '3D-Drucker oder 3D-Scanner kaufen',
    technik: '3D-Drucker oder 3D-Scanner kaufen',
    robotik: 'Roboter & Automation kaufen',
    roboter: 'Roboter & Automation kaufen',
    service: 'Schulung, Inbetriebnahme & Service'
  };

  const setTopic = (value, shouldScroll = false) => {
    if (!topicSelect || !value) return;
    const optionExists = Array.from(topicSelect.options).some((option) => option.value === value);
    if (!optionExists) return;

    topicSelect.value = value;
    if (topicHelp) topicHelp.textContent = topicCopy[value] || topicCopy['Allgemeine Beratung / Sonstiges'];
    if (subjectInput) subjectInput.value = `Website-Anfrage: ${value}`;

    choices.forEach((choice) => {
      const active = choice.dataset.requestTopic === value;
      choice.classList.toggle('is-active', active);
      choice.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (shouldScroll && formSection) {
      formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => topicSelect.focus({ preventScroll: true }), 450);
    }
  };

  choices.forEach((choice) => {
    choice.addEventListener('click', () => setTopic(choice.dataset.requestTopic, true));
  });

  if (topicSelect) {
    topicSelect.addEventListener('change', () => setTopic(topicSelect.value));
  }

  const params = new URLSearchParams(window.location.search);
  const rawTopic = (params.get('thema') || '').trim();
  const mappedTopic = queryMap[rawTopic.toLowerCase()] || rawTopic;
  if (mappedTopic) setTopic(mappedTopic);

  const industrySelect = root.querySelector('#DilbaRequestIndustry');
  const industryParam = (params.get('branche') || '').trim().toLowerCase();
  const industryMap = {
    maschinenbau: 'Maschinen- & Anlagenbau',
    formenbau: 'Werkzeug- & Formenbau',
    automotive: 'Automotive',
    mobilitaet: 'Bau- & Landmaschinen',
    beschlag: 'Beschlagindustrie',
    giesserei: 'Gießerei & Walzenindustrie',
    konsumgueter: 'Konsumgüter',
    luftfahrt: 'Luft- & Raumfahrt',
    medizintechnik: 'Medizin- & Dentaltechnik',
    robotik: 'Robotik & Automation',
    batteriefertigung: 'Batteriefertigung',
    architektur: 'Architektur & Bauwesen',
    sanitaer: 'Sanitär'
  };

  if (industrySelect && industryMap[industryParam]) {
    industrySelect.value = industryMap[industryParam];
  }
})();
